import { defineMessages } from 'react-intl';

export const PromotionComponentLayout3Messages = defineMessages({
  rateText: {
    defaultMessage: 'oder nur {value} pro Monat',
    id: 'infoElementUnito.rate-text',
  },
  buttonText: {
    defaultMessage: 'Finden Sie jetzt Ihre Wunschrate',
    id: 'infoElementUnito.button-text',
  },
  legalText: {
    defaultMessage:
      'Die gesetzlichen Informationen zum Teilzahlungsgeschäft finden Sie <button>hier</button>.',
    id: 'infoElementUnito.legal-text',
  },
  modalHeadline: {
    defaultMessage: 'Flexikonto Teilzahlung',
    id: 'infoElementUnito.modal.headline',
  },
});
